module.exports = __webpack_public_path__ + "img/rightsumo.1999638d.png";